import React, { ReactElement, useCallback, useEffect, useState } from "react";
import { observer } from "mobx-react";
import ProductsSlider from "common/ProductsSlider/ProductsSlider";
import ProductPreview from "common/ProductPreview/ProductPreview";
import { useStore } from "store";
import { useApi } from "services/ApiService";
import { getBrowsingHistoryIds } from "helpers/cookies";
import { gtm } from "helpers/analytics";

type Props = {
  hideCartToast?: boolean;
  className?: string;
};

const BrowsingHistory: React.FC<Props> = ({
  hideCartToast,
  className,
}: Props): ReactElement => {
  const [list, setList] = useState([]);
  const [sliderIsInit, setSliderIsInit] = useState(false);
  const {
    methods: { products },
  } = useApi();
  const { location } = useStore();
  const ids: Array<Entity.ID> = getBrowsingHistoryIds();

  useEffect(() => {
    async function fetchHistory() {
      const { data } = await products.browsingHistory({
        ids,
        regionID: location.regionID,
      });

      if (data && data.products.items) {
        setList(data.products.items);
      }
    }

    ids.length > 0 && fetchHistory();
  }, [location.regionID]);

  const onWatchSlide = useCallback(
    ({ subject, isIntersecting, index }) => {
      if (isIntersecting) {
        gtm.watchProduct(
          subject,
          index + 1,
          "Вы недавно смотрели",
          subject?.category
        );
      }
    },
    [sliderIsInit]
  );

  const onClickSlide = ({ product, index }) => {
    gtm.clickProduct(
      product,
      index + 1,
      "Вы недавно смотрели",
      product?.category
    );
  };

  if (!ids || !list || list.length < 1) {
    return null;
  }

  return (
    <section className={className}>
      <ProductsSlider
        title="Вы недавно смотрели"
        sliderProps={{
          slidesPerView: "auto",
          onInit: () => {
            setSliderIsInit(true);
          },
        }}
      >
        {list.map((product, index) => {
          return (
            <ProductPreview
              onWatch={sliderIsInit ? onWatchSlide : undefined}
              onClick={() => onClickSlide({ product, index })}
              product={product}
              index={index}
              key={product.id}
              type="regular"
              analyticsMeta={{
                position: index + 1,
                list: "Вы недавно смотрели",
                category: product?.category,
              }}
              ellipsis={3}
              hideCartToast={hideCartToast}
              enableCustomPrefixPrice
            />
          );
        })}
      </ProductsSlider>
    </section>
  );
};

export default observer<React.FC<Props>>(BrowsingHistory);
